import {
  type TutorialObjective,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import { defineStore } from 'pinia'

export interface TutorialState {
  anne: {
    showAnne: boolean,
    isRight: boolean
  },
  mobile: boolean,
  tutorialMessage: {
    message: string,
    showMessage: boolean,
    color: TutorialMessageColors,
    offset: boolean
  },
  settings: boolean,
  objectives: TutorialObjective[],
  showObjectives: boolean,
  showButtonStart: boolean,
  showButtonsMovement: boolean,
  showSharpMovement: boolean,
  showBarStart: boolean
}

const initialState = (): TutorialState => ({
  anne: {
    showAnne: false,
    isRight: false
  },
  mobile: false,
  tutorialMessage: {
    message: '',
    showMessage: false,
    color: TutorialMessageColors.blank,
    offset: false
  },
  settings: false,
  objectives: [],
  showObjectives: false,
  showButtonStart: false,
  showButtonsMovement: false,
  showSharpMovement: false,
  showBarStart: false
})

export const tutorialState = defineStore('tutorialState', {
  state: initialState,
})
